export const DEFAULT_HOMEPAGE_SECTIONS = [
  { id: 'fallback-hero', section_type: 'hero' },
  { id: 'fallback-categories', section_type: 'categories' },
  { id: 'fallback-best-sellers', section_type: 'best_sellers' },
  { id: 'fallback-new-arrivals', section_type: 'new_arrivals' },
];

const valueFrom = (result, fallback) => (
  result?.status === 'fulfilled' ? result.value : fallback
);

export function resolveHomepageData(results) {
  const [cmsResult, productsResult, categoriesResult, settingsResult] = results;
  const products = valueFrom(productsResult, null);

  if (!Array.isArray(products)) {
    throw new Error('Products could not be loaded.');
  }

  const sections = valueFrom(cmsResult, DEFAULT_HOMEPAGE_SECTIONS);
  const categories = valueFrom(categoriesResult, []);
  const settings = valueFrom(settingsResult, {});
  const hasOptionalFailure = [cmsResult, categoriesResult, settingsResult]
    .some((result) => result?.status === 'rejected');

  return {
    products,
    sections: Array.isArray(sections) && sections.length ? sections : DEFAULT_HOMEPAGE_SECTIONS,
    categories: Array.isArray(categories) ? categories : [],
    settings: settings && typeof settings === 'object' ? settings : {},
    hasOptionalFailure,
  };
}
